<template>
    <v-container class="text-center">
        <v-row justify="center" dense>
            <v-col cols="12">
                <v-card class="elevation-0">
                    <v-card-text class=" pa-0">
                        <v-icon color="primaryMedium" large>mdi-text-box-multiple-outline</v-icon>

                        <div class="text-h6 font-weight-bold mt-3">
                            No titles here yet
                        </div>

                        <div class="grey--text text--darken-1 mt-2 fs-16">
                            View, subscribe or favorite titles to see them here
                        </div>

                        <v-btn color="primary" class="mt-3" depressed :href="getRoute('codes')">
                            Browse All Codes
                        </v-btn>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'EmptyTitlesCard',
};
</script>
